import { faqs, stats } from './content'
import type { FaqItem, Stat } from './content'

export const kitHero = {
  subheadline: "100 Fiches Visuelles + 6 Kits Professionnels Prêts à l'Emploi",
  description:
    "100 explications prêtes pour vos clients, 24 séances à adapter et 50 erreurs techniques avec leurs corrections pratiques. Tout est organisé pour travailler avec moins d'improvisation.",
}

export const kitStats: Stat[] = stats.map((stat) =>
  stat.label === 'Bonus Pratiques' ? { ...stat, label: 'Kits Professionnels' } : stat,
)

export interface Kit {
  number: string
  title: string
  hook: string
  description: string
}

export const kitsCopy = {
  title: "Et ce n'est pas tout : vous recevez également 6 Kits Professionnels Prêts à l'Emploi.",
  subtitle:
    'Pas seulement des fiches à consulter. Six outils pratiques pour expliquer les exercices, préparer vos séances et organiser votre travail avec vos clients.',
  badge: 'Inclus',
  closing:
    "De l'explication d'un exercice à la première séance avec un client : six outils pratiques pour travailler de manière plus organisée, avec moins d'improvisation.",
  closingNote: 'Les 6 kits sont inclus dans le pack complet.',
}

export const kits: Kit[] = [
  {
    number: '01',
    title: '100 Explications Prêtes pour vos Clients',
    hook: 'Les bons mots pour expliquer chaque exercice.',
    description:
      "100 explications déjà structurées, avec les muscles sollicités, la technique et les conseils pratiques. Ouvrez la fiche et adaptez l'explication à votre client.",
  },
  {
    number: '02',
    title: 'Matrice des Alternatives aux Exercices',
    hook: 'Trouvez la bonne alternative sans repartir de zéro.',
    description:
      'Une matrice prête à consulter, avec des variantes classées par mouvement, niveau et matériel disponible.',
  },
  {
    number: '03',
    title: '24 Séances Prêtes à Adapter',
    hook: "Fini de partir d'une page blanche.",
    description:
      '24 fiches avec exercices, séries, répétitions et enchaînements déjà organisés. Choisissez une séance et personnalisez-la pour votre client.',
  },
  {
    number: '04',
    title: 'Corrections Express : 50 Erreurs Fréquentes',
    hook: "Repérez l'erreur. Sachez quoi observer et comment la corriger.",
    description:
      '50 erreurs techniques courantes, accompagnées de conseils pratiques pour expliquer les corrections plus clairement.',
  },
  {
    number: '05',
    title: 'Kit Fiches Clients et Suivi',
    hook: 'Moins de feuilles éparpillées. Un meilleur suivi des progrès.',
    description:
      'Des modèles prêts à utiliser pour enregistrer les entraînements, les charges, les répétitions et les progrès de vos clients.',
  },
  {
    number: '06',
    title: 'Kit Première Séance Sans Improvisation',
    hook: 'Votre première séance, déjà structurée.',
    description:
      "Check-lists, fiches d'objectifs et déroulé du premier rendez-vous pour accueillir vos nouveaux clients avec plus d'assurance.",
  },
]

export interface KitOfferRow {
  title: string
  detail: string
}

export const kitOffer = {
  label: 'Pack Complet pour Coachs Sportifs',
  name: 'Atlas Visuel de Biomécanique',
  summary: '100 Fiches Visuelles + 6 Kits Professionnels',
  status: 'Inclus',
  bundle: '1 Atlas complet + 6 Kits Professionnels',
  bundleNote: 'Tout est déjà organisé. Un seul achat. Aucun abonnement.',
  priceLabel: 'Tout le système pour seulement',
  price: '19',
  currency: '€',
  priceNote: 'Paiement unique. Accès à vie.',
  cta: 'Oui, je veux le système complet',
  note: 'Paiement sécurisé · Téléchargement immédiat · Garantie de 7 jours',
  closing:
    '100 exercices analysés et 6 outils prêts à utiliser dans votre travail. Le tout réuni dans un seul pack numérique.',
}

export const kitOfferRows: KitOfferRow[] = [
  {
    title: "Atlas Visuel — 100 Fiches d'Exercices",
    detail: 'Muscles, technique, plans anatomiques, erreurs fréquentes et variantes.',
  },
  {
    title: 'Kit Explications et Alternatives',
    detail: '100 explications prêtes + matrice des alternatives aux exercices.',
  },
  {
    title: 'Kit Séances et Corrections',
    detail: '24 séances à adapter + 50 erreurs techniques avec conseils pratiques.',
  },
  {
    title: 'Kit Clients et Première Séance',
    detail: 'Fiches de suivi + outils pour organiser le premier rendez-vous.',
  },
  {
    title: 'Accès Numérique Complet',
    detail: 'PDF imprimables · Accès immédiat · Accès à vie.',
  },
]

export const kitFinalCta = {
  title: "100 exercices analysés. 6 kits prêts à l'emploi. Un seul système.",
  subtitle:
    'Retrouvez les informations et les outils dont vous avez besoin pour expliquer les exercices, préparer vos séances et organiser votre travail avec vos clients, le tout dans un seul pack.',
  summary: '100 Fiches Visuelles + 6 Kits Professionnels',
  cta: 'Je veux le système complet',
}

export const kitFaqs: FaqItem[] = faqs.map((faq) =>
  faq.question === "Contient-il des programmes d'entraînement déjà prêts ?"
    ? {
        question: "Le pack contient-il des séances d'entraînement déjà préparées ?",
        answer:
          "Oui. Vous recevez le kit 24 Séances Prêtes à Adapter, avec des exercices, des séries, des répétitions et des enchaînements déjà organisés. Il ne vous reste plus qu'à les adapter au niveau et aux objectifs de chaque client.",
      }
    : faq,
)
